import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { msgid, ngettext, t } from 'ttag';

import { useNoContractEvents } from '@domains/Organization/queries';

const useContractAlerts = () => {
  const { organizationId } = useParams();
  const { isLoading, data } = useNoContractEvents(organizationId);
  const ManageEventLink = (
    <Link
      key="manage-events-link"
      to={`/organization/${organizationId}/events`}
    >{t`Manage Events`}</Link>
  );

  if (isLoading || data.length === 0) {
    return { isLoading, alerts: [] };
  }

  return {
    isLoading: false,
    alerts: [
      {
        id: 'emailDomain',

        content: [
          ngettext(
            msgid`${data.length} of your events has dates that fall outside the active contract period. Subscription events won’t be accessible to attendees during that time.`,
            `${data.length} of your events have dates that fall outside the active contract period. Subscription events won’t be accessible to attendees during that time.`,
            data.length,
          ),
          ManageEventLink,
        ],
        type: 'error',
        scope: 'organization',
      },
    ],
  };
};

export default useContractAlerts;
